import { Box } from '@mui/material'
import { usePlanBookData } from './PlanningBook.data'
import { useParams } from 'react-router-dom'
import { useMemo } from 'react'
import { useTheme } from '@mui/material/styles'
import { GridColDef, GridToolbar } from '@mui/x-data-grid-premium'
import { autoHeight } from 'Common/utils/utils'
import { BaseTable } from 'Features/Table/BaseTable.view'
import { ExtendedGridColDef } from 'Features/Table/BulkUpdateModal'
const constantColumns = [
  'DestinationSiteCode',
  'Measure',
  'PlannedVersion',
  'SKUCode',
  'SKUName',
  'id',
  'SourceWorkCentreCode',
]

export const PlanningBookView = () => {
  const theme = useTheme()
  const { planId, workcentreId } = useParams<{
    planId: string
    workcentreId: string
  }>()

  const { data: AllplanBookData, isLoading: isPlanBookDataLoading } =
    usePlanBookData(planId, workcentreId)

  const columns: ExtendedGridColDef[] = useMemo(() => {
    if (!(AllplanBookData && AllplanBookData.data.length > 0)) {
      return []
    }
    const colConfig: ExtendedGridColDef[] = [
      {
        field: 'PlannedVersion',
        headerName: 'Planned version',
        width: 150,
        type: 'string',
      },
      {
        field: 'SKUCode',
        headerName: 'SKU code',
        width: 150,
        type: 'string',
      },
      {
        field: 'SKUName',
        headerName: 'SKU name',
        width: 150,
        type: 'string',
      },
      {
        field: 'SourceWorkCentreCode',
        headerName: 'Work centre code',
        width: 150,
        type: 'string',
      },
      {
        field: 'DestinationSiteCode',
        headerName: 'Site code',
        width: 150,
        type: 'string',
      },
      {
        field: 'Measure',
        headerName: 'Key measures',
        width: 250,
        type: 'string',
      },
    ]
    const firstRow = AllplanBookData?.data[0]

    for (const key in firstRow) {
      if (!constantColumns.includes(key)) {
        colConfig.push({
          field: key,
          headerName: key,
          flex: 1,
          type: 'number',
        })
      }
    }

    return colConfig
  }, [AllplanBookData?.data])

  return (
    <Box>
      <Box id="#table-container-mui" sx={{ height: '100%', width: '100%' }}>
        <BaseTable
          isLoading={isPlanBookDataLoading}
          data={AllplanBookData?.data ?? []}
          columns={columns}
          initialState={{
            pagination: { paginationModel: { pageSize: 100 } },
          }}
          updateTableData={() => {}}
          isSaving={false}
        />
      </Box>
    </Box>
  )
}
